export const CULTURE_LIST = [{
  img: 'introduction_culture_img_1.png',
  title: '我们的愿景',
  paragraph: ['打造全球领先的金融科技公司', '打造全国领先的互联网金融信息服务提供商']
}, {
  img: 'introduction_culture_img_2.png',
  title: '我们的使命',
  paragraph: ['让金融变得更简单']
}, {
  img: 'introduction_culture_img_3.png',
  title: '我们的价值观',
  paragraph: ['one for all，all for one', '平凡人做非凡事']
}];
export const HONOR_LIST = ['AdvancedNetwork.png', 'forerunner.png', 'Famoustrademark.png', 'Bestpartner.png', 'BestInnovative.png', 'NationalPlan.png', 'HighTechEnterprises.png', 'CMMI3AA.png', 'ISO9001BB.png'];
export const CONTACT_LIST = [{
  img: 'contact-h.png',
  title: '杭州总部',
  cover: '华东（浙江省、江苏省、安徽省）',
  address: '浙江省杭州市余杭区五常街道同顺街18号同花顺大楼',
  phone: '0571-88911818'
}, {
  img: 'contact-b.png',
  title: '北京分部',
  cover: '东北、华北',
  address: '北京市西城区西直门外大街18号金贸大厦B座2层',
  phone: '010-68145678'
}, {
  img: 'contact-s.png',
  title: '上海分部',
  cover: '华中(河南省、江西省) 华东(山东省、上海市) ',
  address: '上海市浦东新区张杨路1518号陆家嘴金品11楼',
  phone: '021-50458738-507'
}, {
  img: 'contact-z.png',
  title: '深圳分部',
  cover: '华南、西南（云南省、贵州省、广西自治区）',
  address: '深圳市福田区彩田南路2030号澳新亚大厦首座27楼',
  phone: '0755-23824003'
}];